// Import external
import { Injectable } from '@angular/core';
import * as _ from 'lodash';

// Import internal
import { Inventory, typeEnum } from '@data/models/inventory.model';
import { Os, Disk } from '@data/models/server.model';

@Injectable()
export class InventoryUtils {
    public osIco(os: Os): string {
        const name = os?.name?.toLowerCase()?.replace(/\s/g, '') || 'help';

        const osName = {
            'debian': 'brand-debian',
            'centos': 'brand-centos',
            'redhat': 'brand-redhat',
            'ubuntu': 'brand-ubuntu',
            'windows': 'brand-windows'
        };

        return _.find(osName, (v, k) => {
            return name.includes(k);
        }) || 'help';
    }

    public osFamily(os: Os): string {
        const name = os?.name?.toLowerCase()?.replace(/\s/g, '') || 'Unknown';

        const osName = {
            'debian': 'Debian',
            'centos': 'CentOS',
            'redhat': 'Red Hat',
            'ubuntu': 'Ubuntu',
            'windows': 'Windows'
        };

        return _.find(osName, (v, k) => {
            return name.includes(k);
        }) || 'Unknown';
    }

    public assetType(inventory: Inventory): string {
        const type = inventory.type || '';

        switch (type) {
            case typeEnum.SERVER:
                return inventory.subtype === 'PHYSICAL' ? 'physical-server' : 'virtual-server';
            case typeEnum.LOAD_BALANCER:
                return 'Load balancer';
            default:
                return 'Unknown';
        }
    }

    public assetIco(inventory: Inventory): string {
        const type = inventory.type || '';
        switch (type) {
            case typeEnum.SERVER:
                return inventory.subtype === 'PHYSICAL' ? 'physical-server' : 'virtual-server';
            case typeEnum.LOAD_BALANCER:
                return 'workstation';
            default:
                return 'help';
        }
    }

    public diskToChartData(disk: Disk): {name: string; value: number}[] {
        return [
            {name: 'Espace utilisé', value: Math.round((disk.sizeGb - disk.freeGb) * 100) / 100},
            {name: 'Espace libre', value: Math.round(disk.freeGb * 100) / 100}
        ];
    }
}
